import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useEscapeToGoBack = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        navigate(-1); // Go back one page
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [navigate]);
};

export default useEscapeToGoBack;
